"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineDisplayTotal = void 0;
const roundTo_1 = require("../roundTo");
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const getOrderLineDisplayTotal = (item, exchange_rate) => {
    if (!exchange_rate || exchange_rate?.rate === 1)
        return 0;
    // format to two decimal places
    return (0, roundTo_1.roundTo)((0, getOrderLineTotal_1.getOrderLineTotal)(item) * exchange_rate.rate, 2);
};
exports.getOrderLineDisplayTotal = getOrderLineDisplayTotal;
